import dynamic from "next/dynamic";
import { FaPlay } from "react-icons/fa";
import { ShortsVideo } from "types/event";

interface Props {
  video: ShortsVideo;
  onClick: () => void;
}

// ReactPlayer supports HLS via hls.js with native fallback; disable SSR to avoid build-time window usage
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });

export default function VideoCard({ video, onClick,  }: Props) {


  
  // const isCurrentPlaying = runningVideo === video?._id
  return (
    <div
      className="relative aspect-[9/16] max-w-[200px] md:max-w-auto gap-4   rounded-xl overflow-hidden shadow-md cursor-pointer group"
      onClick={onClick}
    >
      <ReactPlayer onLoad={() => alert("")}
        src={video.url}
        playing={false}
        muted
        playsInline
        preload="auto"
        width="100%"
        height="100%"
        className="w-full h-full aspect-[9/16] rounded-xl object-cover"
      />

      {/* Top-Left Video Icon */}
      {/* <div className="absolute top-2 left-2 text-white p-1 rounded-md text-xs">
        <FaVideo />
      </div> */}

      {/* Top-Right */}
      <div className="absolute top-2 right-2 text-white px-2 py-1 rounded-md text-sm font-arabic">
        {video.performer ?? ""}
      </div>

      <button
        className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/50 transition">
        <FaPlay className="text-white text-3xl" />
      </button>

      {/* Bottom Instagram Link */}
      {/* <a
        href={video.instagramUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()} // Prevent modal from opening
        className="absolute bottom-2 right-2 flex items-center space-x-1 text-white text-sm px-2 py-1 rounded-md"
      >
        <span>@laplaya.sa</span>
        <FaInstagram className="text-base" />
      </a> */}
    </div>
  );
}
